import { useEffect, useState } from "react";
import useFetch from "../../../../hooks/useFetch";
import { getAPIHeaders } from "../../../../common/Utils";
import { API } from "../../../../common/Constants";
import { Link } from "react-router";
import PreLoader from "../../../../core/common/preLoader";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import Table from "../../../../core/common/dataTable/index";
import ModifyAssessment from "./modifyAssessment";
import { useNavigate } from "react-router"
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import { Assessment, AssessmentStats } from "../../../../types/dataModel";
import AssessmentCourses from "./assessmentCourses";
import { useAccess } from "../../../../hooks/accessContext";
import CustomToast from "../../../../core/common/customToast";
import DeleteModal from '../../../../core/modals/deleteModal';
import AiAssessmentGeneration from "./aiAssessmentGeneration";

const AssessmentView = () => {
  const { hasPerformanceMgntCreate, hasPerformanceMgntEdit, hasPerformanceMgntDelete } = useAccess();
  const navigation = useNavigate();
  const { isLoading, error, callFetch } = useFetch();
  const [assessments, setAssessments] = useState<Assessment[]>([]);
  const [assessmentStats, setAssessmentStats] = useState<AssessmentStats>();
  const [editId, setEditId] = useState<number>(0);
  const [aiAssessmentId, setAiAssessmentId] = useState<number | null>(null);
  const [showAiGenerationModal, setShowAiGenerationModal] = useState<boolean>(false);
  const [viewType, setViewType] = useState<'table' | 'card'>('table');
  const [deleteItem, setDeleteItem] = useState<any>({
    id: undefined,
    message: undefined,
  });
  const [toastSettings, setToastSettings] = useState<{
    show: boolean;
    message: string;
    heading: string;
    type: "ERROR" | "SUCCESS" | "INFO";
  }>({
    show: false,
    message: "",
    heading: "",
    type: "ERROR",
  });

  const onToastClose = () => {
    setToastSettings({
      show: false,
      message: "",
      heading: "",
      type: "ERROR",
    });
  };

  useEffect(() => {
    if (error) {
      if (error.response?.data) {
        setToastSettings({
          message: error?.response?.data,
          heading: "Ooops",
          show: true,
          type: "ERROR"
        })
      } else {
        setToastSettings({
          message: 'Something went wrong please try again later.',
          heading: "Ooops",
          show: true,
          type: "ERROR"
        })
      }
    }
  }, [error]);


  useEffect(() => {
    fetchAssessmentCourses();
    fetchAssessmentStats();
  }, []);


  const fetchAssessmentCourses = () => {
    callFetch(API.ASSESSMENT_COURSES,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res) => {
      setAssessments(res)
    });
  }

    const fetchAssessmentStats = () => {
    callFetch(API.ASSESSMENT_STATS,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res) => {
      setAssessmentStats(res)
    });
  }

  const setAssessmentLive = (id: number, assStatus?: boolean) => {
    if (assStatus) {
      callFetch(`${API.ASSESSMENT}/${id}/live`,
        'POST',
        getAPIHeaders(),
        null,
        null
      ).then((res) => {
        if (res) {
          fetchAssessmentCourses()
        }
      })
    }
  }

  const deleteData = (id: number) => {
    callFetch(
      `${API.ASSESSMENT}/${id}`,
      'DELETE',
      getAPIHeaders(),
      null,
      null
    )
      .then(() => {
        fetchAssessmentCourses();
      })
      .catch(() => {
        setToastSettings((prev) => ({
          ...prev,
          show: true,
        }));
      });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: String, record: any) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>

      ),
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "Assessment",
      dataIndex: "title",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <h6 className="fw-medium">

                {record.title}

              </h6>
            </p>
            <span className="fs-12 description-content">{record.description}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.title?.localeCompare(b.title),
      defaultSortOrder: "ascend",
    },
    {
      title: "Code",
      dataIndex: "code",
      sorter: (a: any, b: any) => a.code?.localeCompare(b.code),
    },
    {
      title: "Is Live",
      dataIndex: "isLive",
      render: (text: String, record: any) => (
        <div className="form-check form-check-md form-switch">
          <input className="form-check-input me-2"
            hidden={!hasPerformanceMgntEdit()}
            role="switch"
            type="checkbox"
            checked={record?.isLive ? true : false}
            disabled={record?.isLive}
            onChange={(e) => {
              setAssessmentLive(record.id, e?.target?.checked)
            }}
          />
          {
            record.isLive
              ?
              <span className="badge badge-soft-primary d-inline-flex align-items-center badge-sm">
                {record.status}
              </span>
              :
              <span className="badge badge-soft-dark d-inline-flex align-items-center badge-sm">
                {record.status}
              </span>
          }
        </div>

      ),
      sorter: (a: any, b: any) => a?.status?.localeCompare(b.status),
    },      
    {
        title: "Actions",
        dataIndex: "actions",
        render: (text: string, record: any) => (
          <div className="action-icon d-inline-flex">
            <button className="btn btn-sm btn-secondary me-2"
              onClick={() => {
                navigation(`${all_routes.assessment_questions}?id=${record?.id}`);
              }}>
              Questions
            </button>
            <button className="btn btn-sm btn-secondary me-2"
              data-bs-toggle="modal" data-inert={true}
              data-bs-target="#modify_courses"
              onClick={() => { setEditId(record?.id) }}>
              Courses
            </button>
            {!record?.isLive && hasPerformanceMgntCreate() && (
              <button 
                className="btn btn-sm btn-secondary me-2"
                onClick={() => { 
                  setShowAiGenerationModal(true);
                  setAiAssessmentId(record?.id) 
                }}
                title="Generate Questions with AI"
              >
                <i className="ti ti-robot me-1"></i> AI Generator
              </button>
            )}
            <Link
              hidden={!hasPerformanceMgntEdit() || record?.isLive}
              to="#"
              className="me-2 icon-edit"
              data-bs-toggle="modal" data-inert={true}
              data-bs-target="#modify_assessment"
              onClick={() => { setEditId(record?.id) }}
              title="Edit Assessment"
            >
              <i className="ti ti-edit" />
            </Link>
          <Link
            hidden={!hasPerformanceMgntDelete()}
            to="#"
            className="icon-delete"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() =>
              setDeleteItem({
                id: record.id,
                message: `Are you sure you want to delete ${record.title}? This can't be undone.`,
              })
            }
            title="Delete Assessment"
          >
            <i className="ti ti-trash" />
          </Link>
        </div>

      ),
    },
  ]

  const renderEditAssessment = () => {
    return (
      <ModifyAssessment
        onCancel={() => {
          setEditId(0)
        }}
        onSuccess={fetchAssessmentCourses}
        id={editId} />
    )
  }

  const renderAssessmentCourses = () => {
    return (
      <AssessmentCourses
        onSuccess={fetchAssessmentCourses}
        assessment={assessments?.find((item) => item.id === editId)} />
    )
  }

  const renderAiAssessmentGeneration = () => {
    return (
      <AiAssessmentGeneration
        show={showAiGenerationModal}
        onCancel={() => {
          setAiAssessmentId(null)
          setShowAiGenerationModal(false);
        }}
        onSuccess={() => {
          fetchAssessmentCourses();
        }}
        assessment={assessments?.find((item) => item.id === aiAssessmentId)} />
    )
  }

  const renderStatsCards = () => {
    return (
      <div className="row">
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Total Assessments</p>
                        <h4>{assessmentStats?.totalAssessments}</h4>
                    </div>
                    <div><span className="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center"><i className="ti ti-graph text-pink fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Published Assessments</p>
                        <h4>{assessmentStats?.publishedAssessments}</h4>
                    </div>
                    <div><span className="p-2 br-10 bg-transparent-primary border border-primary d-flex align-items-center justify-content-center"><i className="ti ti-graph text-primary fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Draft Assessments</p>
                        <h4>{assessmentStats?.draftAssessments}</h4>
                    </div>
                    <div><span className="p-2 br-10 bg-transparent-purple border border-purple d-flex align-items-center justify-content-center"><i className="ti ti-graph text-purple fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
        <div className="col-xl-3 col-md-6">
            <div className="card">
              <div className="card-body">
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5">Courseless Assessments</p>
                        <h4>{assessmentStats?.draftAssessmentWithoutCourses}</h4>
                    </div>
                    <div><span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center"><i className="ti ti-graph text-danger fs-18"></i></span></div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <CustomToast
        show={toastSettings?.show}
        message={toastSettings?.message}
        heading={toastSettings?.heading}
        type={toastSettings?.type}
        onClose={onToastClose} />
      <PreLoader showLoader={isLoading} />
      <DeleteModal
        heading="Confirm Delete"
        message={deleteItem.message}
        onDelete={() => deleteData(deleteItem?.id)}
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Assessments</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Assessments
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <button
                  disabled={!hasPerformanceMgntCreate()}
                  data-bs-toggle="modal" data-inert={true}
                  data-bs-target="#modify_assessment"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => {
                    setEditId(-1)
                  }}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Assessment
                </button>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {renderStatsCards()}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Assessment List</h5>
              <div className="view-toggle">
                <button 
                  className={`btn btn-sm me-2 ${viewType === 'table' ? 'btn-primary' : 'btn-outline-primary'}`} 
                  onClick={() => setViewType('table')}
                  aria-label="Switch to table view"
                >
                  <i className="ti ti-table me-1"></i> Table View
                </button>
                <button 
                  className={`btn btn-sm ${viewType === 'card' ? 'btn-primary' : 'btn-outline-primary'}`} 
                  onClick={() => setViewType('card')}
                  aria-label="Switch to card view"
                >
                  <i className="ti ti-layout-grid me-1"></i> Card View
                </button>
              </div>
            </div>
            <div className="card-body p-0">
              {viewType === 'table' ? (
                <Table dataSource={assessments} columns={columns} Selection={false} refresh={fetchAssessmentCourses} />
              ) : (
                <div className="assessment-cards p-3">
                  <div className="row">
                    {assessments.map((assessment: any) => (
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3" key={assessment.id}>
                        <div className="card h-100 border shadow-sm">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div className="d-flex align-items-center">
                                <div className="avatar avatar-sm me-3 flex-shrink-0 bg-light-primary rounded-circle">
                                  <span className="text-primary fw-bold">
                                    {assessment.title.charAt(0).toUpperCase()}
                                  </span>
                                </div>
                                <div>
                                  <h6 className="mb-0 fw-semibold assessment-title">
                                    {assessment.title}
                                  </h6>
                                  <small className="text-muted">Code: {assessment.code}</small>
                                </div>
                              </div>
                              {assessment.isLive ? (
                                <span className="badge badge-soft-primary">Live</span>
                              ) : (
                                <span className="badge badge-soft-dark">Draft</span>
                              )}
                            </div>
                            
                            <div className="assessment-description mb-3">
                              <p className="fs-12 text-muted mb-0">
                                {assessment.description}
                              </p>
                            </div>
                            
                            <div className="d-flex flex-wrap justify-content-end gap-2 mt-3">
                              <button 
                                className="btn btn-sm btn-secondary"
                                onClick={() => {
                                  navigation(`${all_routes.assessment_questions}?id=${assessment?.id}`);
                                }}
                              >
                                <i className="ti ti-list-check me-1"></i> Questions
                              </button>
                              <button 
                                className="btn btn-sm btn-secondary"
                                data-bs-toggle="modal" 
                                data-inert={true}
                                data-bs-target="#modify_courses"
                                onClick={() => { setEditId(assessment?.id) }}
                              >
                                <i className="ti ti-book me-1"></i> Courses
                              </button>
                              
                              {!assessment?.isLive && hasPerformanceMgntCreate() && (
                                <button 
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => { 
                                    setAiAssessmentId(assessment?.id); 
                                    setShowAiGenerationModal(true);  
                                  }}
                                >
                                  <i className="ti ti-robot me-1"></i> AI Generator
                                </button>
                              )}
                              
                              <div className="mt-2 w-100 d-flex justify-content-between">
                                <div className="form-check form-check-md form-switch align-self-center">
                                  <input 
                                    className="form-check-input me-2"
                                    hidden={!hasPerformanceMgntEdit()}
                                    role="switch"
                                    type="checkbox"
                                    checked={assessment?.isLive ? true : false}
                                    disabled={assessment?.isLive}
                                    onChange={(e) => {
                                      setAssessmentLive(assessment.id, e?.target?.checked)
                                    }}
                                  />
                                </div>
                                
                                <div>
                                  <Link
                                    hidden={!hasPerformanceMgntEdit() || assessment?.isLive}
                                    to="#"
                                    className="btn btn-sm btn-outline-primary me-2"
                                    data-bs-toggle="modal" 
                                    data-inert={true}
                                    data-bs-target="#modify_assessment"
                                    onClick={() => { setEditId(assessment?.id) }}
                                  >
                                    <i className="ti ti-edit me-1"></i> Edit
                                  </Link>
                                  <Link
                                    hidden={!hasPerformanceMgntDelete()}
                                    to="#"
                                    className="btn btn-sm btn-outline-danger"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#delete_modal"
                                    onClick={() => setDeleteItem({
                                      id: assessment.id,
                                      message: `Are you sure you want to delete ${assessment.title}? This can't be undone.`,
                                    })}
                                  >
                                    <i className="ti ti-trash me-1"></i> Delete
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo />
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Edit Assessment */}
      <div className="modal fade"
        id="modify_assessment"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
        {renderEditAssessment()}
      </div>

      <div className="modal fade"
        id="modify_courses"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
        {renderAssessmentCourses()}
      </div>


      {renderAiAssessmentGeneration()}
      
      {/* /Edit Assessment */}
    </>


  )

}

export default AssessmentView